import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo la guía?',
  a: 'Acceso digital INMEDIATO. Después del pago recibes un correo con el enlace para descargar TODO en menos de 60 segundos.'
}, {
  q: '¿Sirve si soy mamá primeriza y no sé cocinar?',
  a: 'SÍ. La mayoría de recetas son de 5 ingredientes y 15 minutos. Si sabes calentar agua, puedes hacerlas.'
}, {
  q: '¿Es un pago único o suscripción?',
  a: 'Pago ÚNICO de $14.99. Sin cargos mensuales. Sin letra pequeña. Acceso de por vida + actualizaciones gratis.'
}];
export function FAQ() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-[#FFF1F4]" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-43">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D1F1A] tracking-tight" data-id="element-44">
            PREGUNTAS <em className="text-[#F9A8B7] not-italic" data-id="element-45">FRECUENTES</em>
          </h2>
        </motion.div>
        <div className="space-y-4 md:space-y-6" data-id="element-46">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-white p-5 md:p-9 rounded-2xl shadow-sm border border-[#A9D7E2]/30" data-id="element-47">
              <h3 className="text-base md:text-2xl font-bold text-[#2D1F1A] mb-2 md:mb-4 flex items-start gap-2 md:gap-3 leading-tight" data-id="element-48">
                <span className="text-[#F9A8B7] flex-shrink-0" data-id="element-49">❓</span>
                <span data-id="element-50">{faq.q}</span>
              </h3>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed pl-7 md:pl-9" data-id="element-51">
                {faq.a}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}